module.exports = __webpack_public_path__ + "img/ic_flat_coin.2559bf49.png";